import { configureAuthentication, fetchHelper } from './api'
import { authActions } from '../redux/authSlice'
import { getErrorMessage } from '../util/functions'
import { UserTypes } from '../util/constants'

export const signUp = (values, accountcategory) => async dispatch => {
    dispatch(authActions.submitFormRequest())
    try {
        const response = await fetchHelper.post('Customer', {
            domainName: null,
            ...values,
            accountcategory,
            accounttype: null,
        })
        if (response?.data?.token) {
            let { token } = response?.data
            configureAuthentication(token)
        }
        dispatch(
            authActions.submitFormRequestSuccess({ data: response?.data?.data })
        )
    } catch (e) {
        dispatch(
            authActions.submitFormRequestError({ error: getErrorMessage(e) })
        )
    }
}

export const signUpBeneficiary = ({
    email,
    firstname,
    lastname,
    password,
}) => async dispatch => {
    dispatch(authActions.submitFormRequest())
    try {
        const response = await fetchHelper.post(
            `Beneficiary/Signup/${email}/${firstname}/${lastname}/${password}`
        )
        dispatch(authActions.submitFormRequestSuccess({ data: response.data }))
    } catch (e) {
        dispatch(
            authActions.submitFormRequestError({ error: getErrorMessage(e) })
        )
    }
}

export const fetchCompanyLogo = email =>
    fetchHelper(`Customer/GetCompanyLogo/${email}`)
        .then(response => response.data)
        .catch(e => {
            if (e.response?.status === 404) {
                return null
            } else {
                return Promise.reject({
                    response: {
                        data: e.response?.data || 'Error fetching logo',
                    },
                })
            }
        })

export const login = values => async dispatch => {
    dispatch(authActions.submitFormRequest())
    try {
        const response = await fetchHelper.post('Customer/Authenticate', values)
        const { success, data, token } = response.data
        if (success === true) {
            configureAuthentication(token)

            let logo
            if (response.accountcategory === UserTypes.Business) {
                const { email } = data
                logo = await fetchCompanyLogo(email)
            }
            dispatch(
                authActions.submitFormRequestSuccess({
                    data: {
                        ...data,
                        domainName: data.domainName || values.domainName,
                        logo,
                    },
                })
            )
        } else {
            dispatch(
                authActions.submitFormRequestError({ error: 'Invalid details' })
            )
        }
    } catch (e) {
        console.log(e)
        if ([400, 401].includes(e.response?.status)) {
            dispatch(
                authActions.submitFormRequestError({ error: 'Invalid details' })
            )
        } else {
            dispatch(
                authActions.submitFormRequestError({
                    error: getErrorMessage(e),
                })
            )
        }
    }
}

export const sendResetLink = ({
    email,
    isBeneficiary = false,
}) => async dispatch => {
    dispatch(authActions.submitFormRequest())
    try {
        await fetchHelper.post(
            `Customer/SendResetLink/${email}?isBeneficiary=${isBeneficiary}`
        )
        dispatch(authActions.submitFormRequestSuccess({}))
    } catch (e) {
        dispatch(
            authActions.submitFormRequestError({
                error: getErrorMessage(e),
            })
        )
    }
}

export const resetPassword = ({ token, password }) => async dispatch => {
    dispatch(authActions.submitFormRequest())
    try {
        await fetchHelper.post(`Customer/ResetPassword`, {
            token,
            newpassword: password,
        })
        dispatch(authActions.submitFormRequestSuccess({}))
    } catch (e) {
        if (e.request?.status === 400) {
            dispatch(
                authActions.submitFormRequestError({
                    error: 'Reset token invalid or has expired',
                })
            )
        } else {
            dispatch(
                authActions.submitFormRequestError({
                    error: getErrorMessage(e),
                })
            )
        }
    }
}
